import { WH_NAMES, useWh } from "@/lib/wh";

export function WhSwitch() {
  const { wh, setWh, allowed } = useWh();
  if (allowed.length < 2) return null;
  return (
    <div className="inline-flex rounded-full border border-[var(--border)] bg-white p-1" data-testid="wh-switch">
      {allowed.map((k) => (
        <button key={k} onClick={() => setWh(k)} data-testid={`wh-switch-${k}`}
          className={`h-9 px-4 rounded-full text-sm font-semibold transition-colors ${wh === k ? "bg-[var(--ink)] text-white" : "text-[var(--muted)]"}`}>{WH_NAMES[k]}</button>
      ))}
    </div>
  );
}
